import { VariantType } from '../types';

export const checkVariant = (variantA?: unknown, variantB?: VariantType) =>
  variantA?.toString().toLowerCase() === variantB?.toString()?.toLowerCase();
